"use strict";

exports.__esModule = true;
exports.default = void 0;
var _baseIsNative = _interopRequireDefault(require("./_baseIsNative.js"));
var _getValue = _interopRequireDefault(require("./_getValue.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = (0, _getValue.default)(object, key);
  return (0, _baseIsNative.default)(value) ? value : undefined;
}
var _default = exports.default = getNative;